import { Alert, Box, Divider, Snackbar, SnackbarCloseReason, Typography } from '@mui/material';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { httpClient } from '../../../../api/http/http-client';
import Camera02Icon from '../../../../components/Icons/camera-02-icon';
import ClockIcon from '../../../../components/Icons/ClockIcon';
import Copy06Icon from '../../../../components/Icons/copy-06-icon';
import LightBulb02Icon from '../../../../components/Icons/lightbulb-02-icon';
import User02Icon from '../../../../components/Icons/user-02-icon';
import { colors } from '../../../../components/ThemeProvider/themeColors';
import { digitalAccountApiUrl } from '../../../../constants/enviroments';
import { useDigitalContext } from '../../../../context/digital';
import { VideoCallResponse } from '../../../../shared/types/digital-account/steps';
import InputField from '../../../../shared/ui/elements/Input';
import VideoCallFrame from './components/frame';

export default function VideoCall() {
  const { state } = useDigitalContext();
  const [open, setOpen] = useState(false);
  const lang = location.pathname.substring(0, 3);
  const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
  const port = typeof window !== 'undefined' ? window.location.port : '';
  const protocol = typeof window !== 'undefined' ? window.location.protocol : 'https:';

  const searchParams = new URLSearchParams(
    typeof window !== 'undefined' ? window.location.search : ''
  );
  const videcallIdFromUrl = searchParams.get('videocall_id');
  const { data } = useQuery({
    queryKey: ['video-call', videcallIdFromUrl],
    queryFn: async (): Promise<VideoCallResponse> =>
      await httpClient.post(
        `${digitalAccountApiUrl}/onboarding?business_key=${state.business_key || ''}&access_token=${state.business_key || ''}`,
        {
          stage: 'videocall',
          videocall_id: videcallIdFromUrl,
        }
      ),
  });

  const videocall_redirect_url = `${protocol}//${hostname}${port ? `:${port}` : ''}${lang}/register`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(videocall_redirect_url);
    handleOpenSnackBar();
  };

  const handleOpenSnackBar = () => {
    setOpen(true);
  };

  const handleCloseSnackBar = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <img src={'/images/digital_account/video_call_main.png'} alt={'video_call'} />
        <Typography textAlign={'center'} fontSize={28} lineHeight={1.5} fontWeight={600}>
          Video zəng ilə şəxsiyyətin təsdiqlənməsi
        </Typography>
        <Box sx={{ marginTop: '24px', display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ display: 'flex', gap: '12px', paddingTop: '12px', paddingBottom: '12px' }}>
            <ClockIcon sx={{ width: '24px', height: '24px' }} />
            <Typography>Zəngə cari gün saat 09:00–17:00 arası qoşulmağınız tələb olunur</Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: '12px', paddingTop: '12px', paddingBottom: '12px' }}>
            <Camera02Icon />
            <Typography>Kamera və mikrofon işlək vəziyyətdə olmalıdır</Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: '12px', paddingTop: '12px' }}>
            <LightBulb02Icon />
            <Typography>İşıqlı, sakit və qapalı məkanda olmağınız tövsiyyə olunur</Typography>
          </Box>
        </Box>
        <Box sx={{ marginTop: '24px', display: 'flex', flexDirection: 'column' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              padding: '12px',
              gap: '12px',
              backgroundColor: '#EEF6FD',
              border: 1,
              borderRadius: '10px',
              borderColor: '#8DC6E7',
            }}
          >
            <User02Icon />
            <Box>
              <Typography fontWeight={600}>Video zəngə qoşulmalı olan şəxs:</Typography>
              <Typography>{data?.ceo_name}</Typography>
            </Box>
          </Box>
          <VideoCallFrame />
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Divider sx={{ my: 2, width: '240px', color: colors.base[400] }}>və ya</Divider>
          </Box>
          <Typography fontWeight={600}>
            Daha sonra qoşulmaq və ya paylaşmaq üçün video zəng linkini kopyalayın
          </Typography>
          <InputField
            disabled={true}
            endAdornment={
              <Copy06Icon onClick={copyToClipboard} sx={{ cursor: 'pointer', width: '20px' }} />
            }
            // value={data?.videocall_url}
            value={videocall_redirect_url}
          ></InputField>
        </Box>
      </Box>

      <Snackbar open={open} autoHideDuration={3000} onClose={handleCloseSnackBar}>
        <Alert
          onClose={handleCloseSnackBar}
          severity='success'
          variant='filled'
          sx={{ width: '100%' }}
        >
          Link kopyalandı
        </Alert>
      </Snackbar>
    </>
  );
}
